import React from "react"
import {FieldViewProps} from "../../render/view";

export default function FieldProto_ViewReference(props: FieldViewProps) {

    const value = props.field.getViewValue(props.model)

    return (
        <div className="ui5-txt-default ui5-txt-red">Reference View is Not Implemented for this field</div>
    )

}